const SvgIconYieldAlt = (props) => (
  <svg viewBox="0 0 89 89" xmlns="http://www.w3.org/2000/svg">
    <path d="M89 0v89H0L89 0Z" fill="#F0F4FF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.875 44.53v-.032c-.004-9.214-3.74-17.555-9.78-23.593L20.878 68.124c6.042 6.042 14.39 9.779 23.61 9.779 18.434 0 33.38-14.94 33.388-33.373Z"
      fill="#F06C22"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.186 25.865a33.548 33.548 0 0 0-4.09-4.96l-47.22 47.219c-6.042-6.043-9.779-14.39-9.779-23.61 0-18.44 14.949-33.389 33.389-33.389 11.534 0 21.701 5.848 27.7 14.74Z"
      fill="#D3DDFF"
    />
  </svg>
);

export default SvgIconYieldAlt;
